import React from 'react';
import PropTypes from 'prop-types';

// The pill on/off switch that enables a modifier (Tax Withholding,
// Merchandising, Promoter Profit). Rendered in the collapsible header, to the
// left of the title. Styles: .simple-mod__switch in simpleOfferLayout.css.
const ModifierSwitch = ({ on, onToggle, label, testId }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={label}
    data-testid={testId}
    className={`simple-mod__switch ${on ? 'is-on' : ''}`}
    onClick={onToggle}
  >
    <span className="simple-mod__switch-knob" />
  </button>
);

ModifierSwitch.propTypes = {
  on: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  testId: PropTypes.string,
};

ModifierSwitch.defaultProps = { testId: undefined };

export default ModifierSwitch;
